import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. Can a Non-US Resident or Non-US Citizen Incorporate a Business in the USA?",
      answer: (
        <>
          <p>Yes! Non-US residents can legally incorporate a business in the U.S. You do not need to be a U.S. citizen or have a U.S. address. However, you will need:</p>
          <ul>
            <li>A Registered Agent in the U.S.</li>
            <li>An EIN (Employer Identification Number) to open a bank account and file taxes</li>
          </ul>
        </>
      )
    },
    {
      question: "2. What Business Structures Can I Choose From?",
      answer: (
        <>
          <p>The most common business structures in the U.S. are:</p>
          <ul>
            <li><strong>LLC (Limited Liability Company)</strong> – Best for small to medium businesses, offering flexibility and tax advantages</li>
            <li><strong>C-Corporation (C-Corp)</strong> – Ideal for startups, tech companies, and businesses seeking investment or planning an IPO</li>
          </ul>
        </>
      )
    },
    {
      question: "3. What is a Registered Agent, and Do I Need One?",
      answer: (
        <>
          <p><span role="img" aria-label="important">📌</span> A Registered Agent is a legally required person or company that receives official documents on behalf of your business.</p>
          <ul>
            <li>All LLCs and Corporations must have a Registered Agent in the state where they are formed</li>
            <li>We provide Registered Agent services in all 50 states</li>
          </ul>
        </>
      )
    },    
    {
      question: "4. What is an EIN (Employer Identification Number), and Why Do I Need It?",
      answer: (
        <>
          <p><span role="img" aria-label="point">🔹</span> An EIN (also called a Tax ID) is required for:</p>
          <ul>
            <li>Opening a U.S. business bank account</li>
            <li>Filing U.S. taxes</li>
            <li>Hiring employees in the U.S.</li>
          </ul>
        
        </>
      )
    },
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="faq-section py-5">
      <div className="container">
        {/* Heading with "See Plan" link on the right */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="section-title1">USA Company Formation FAQs</h2>
          <Link to="/pricing" className="see-plan-link">
            See Plan &rarr;
          </Link>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                const isString = typeof faq.answer === 'string';
                return (
                  <div className="faq-item" key={index}>
                    <button
                      type="button"
                      className="faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="faq-question m-0">{faq.question}</h5>
                      <span className="faq-icon" aria-hidden>{isOpen ? '−' : '+'}</span>
                    </button>
                    <div
                      id={`faq-content-${index}`}
                      className={`faq-content ${isOpen ? 'open' : ''}`}
                      role="region"
                    >
                      <div className="faq-content-inner">
                        {isString ? (
                          <p className="faq-answer" style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>{faq.answer}</p>
                        ) : (
                          <div className="faq-answer">{faq.answer}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;